<div class="department-container">
  <section class="leftbar">
    <app-department-filter-component
      [selectedDepartment]="selectedDepartment"
      [listOfDepartmentsFromApi]="listOfDepartmentsFromApi"
      (filterByDateChanged)="handleFilterByDateChanged($event)"
      (selectedDepartmentChanged)="handleSelectedDepartmentChange($event)"
    >
      ></app-department-filter-component
    >
  </section>
  <div
    *ngIf="
      selectedDepartment && (selectedDepartmentTotals$ | async)?.count;
      then thenBlock;
      else elseBlock
    "
  ></div>

  <ng-template #thenBlock>
    <section class="rightbar">
      <div
        *ngIf="selectedDepartment && dateRange"
        fxLayout="row-reverse"
        class="toolbar"
      >
        <button
          class="csv-download"
          (click)="onDataWorkCsvDownloadClicked()"
          mat-flat-button
        >
          <mat-icon>download</mat-icon> Data Works CSV
        </button>
      </div>
      <div class="department-chart-section">
        <app-department-info
          [selectedDepartment]="selectedDepartment"
        ></app-department-info>
      </div>
      <div class="department-total-jobs-section">
        <app-department-totals
          [selectedDepartmentTotals$]="selectedDepartmentTotals$"
        ></app-department-totals>
        <app-department-total-jobs
          [departmentTotalJobsList]="departmentTotalJobsList"
        ></app-department-total-jobs>
      </div>
    </section>
  </ng-template>
  <ng-template #elseBlock>
    <section>
      <mat-card>
        <mat-card-content>
          no data to display, refine your search criteria or select one of the
          available departments.
        </mat-card-content>
      </mat-card>
    </section>
  </ng-template>
</div>
